// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The container */
.check-container,.check-container-disabled {
  display: block;
  position: relative;
  left:35%;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  user-select: none;
}

.containerWithoutLeft{
  left:0 !important;
}

/* Hide the browser's default checkbox */
.check-container input,.check-container-disabled input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  border-radius:4px;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: white;
  border-radius:4px;
  border:1px solid black;
}

/* When the checkbox is checked, add a blue background */
.check-container input:checked ~ .checkmark {
  background-color: green;
  border:1px solid green;
}

.check-container-disabled input:checked ~ .checkmark {
  background-color: green;
  border:1px solid green;
  opacity:0.3;
}
/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.check-container input:checked ~ .checkmark:after,.check-container-disabled input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.check-container .checkmark:after,.check-container-disabled .checkmark:after {
  left: 5px;
  top: 2px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-radius:4px;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}




`, "",{"version":3,"sources":["webpack://./src/Components/Checkbox/Checkbox.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;EACR,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;AACb;AACA,6DAA6D;AAC7D;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EAGvB,wBAAwB;AAC5B","sourcesContent":["/* The container */\n.check-container,.check-container-disabled {\n  display: block;\n  position: relative;\n  left:35%;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.containerWithoutLeft{\n  left:0 !important;\n}\n\n/* Hide the browser's default checkbox */\n.check-container input,.check-container-disabled input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n  border-radius:4px;\n}\n\n/* Create a custom checkbox */\n.checkmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 15px;\n  width: 15px;\n  background-color: white;\n  border-radius:4px;\n  border:1px solid black;\n}\n\n/* When the checkbox is checked, add a blue background */\n.check-container input:checked ~ .checkmark {\n  background-color: green;\n  border:1px solid green;\n}\n\n.check-container-disabled input:checked ~ .checkmark {\n  background-color: green;\n  border:1px solid green;\n  opacity:0.3;\n}\n/* Create the checkmark/indicator (hidden when not checked) */\n.checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n/* Show the checkmark when checked */\n.check-container input:checked ~ .checkmark:after,.check-container-disabled input:checked ~ .checkmark:after {\n  display: block;\n}\n\n/* Style the checkmark/indicator */\n.check-container .checkmark:after,.check-container-disabled .checkmark:after {\n  left: 5px;\n  top: 2px;\n  width: 4px;\n  height: 8px;\n  border: solid white;\n  border-radius:4px;\n  border-width: 0 2px 2px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n    transform: rotate(45deg);\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
